import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const RoleManagementContent = lazy(() => import('./RoleManagementContent'));



const RoleManagement = () => {
    return (  
        <Suspense fallback={<DefaultLoader />}>
            <RoleManagementContent />
        </Suspense>
    );
}

export default RoleManagement;